/**
 * BiblioService - HTTP client for the "Mi tienda" (Biblio) module.
 * Mirrors AccountsUsersService: injects the auth header and normalises the
 * {status,msg,data} envelope so components stay free of raw HTTP.
 */
import {
    urlInk,
    endpointBiblioList,
    endpointBiblioAvailableAccounts,
    endpointBiblioGet,
    endpointBiblioCreate,
    endpointBiblioUpdate,
    endpointBiblioDeploy,
    endpointBiblioPause,
    endpointBiblioDelete,
    endpointBiblioReport,
} from "./Endpoints";
import AuthService from "./AuthService";

class BiblioService {
    async request(endpoint, options = {}) {
        const token = AuthService.getToken();
        const headers = { ...(options.headers || {}) };
        if (!(options.body instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
        }
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const response = await fetch(`${urlInk}${endpoint}`, {
            method: options.method || 'GET',
            headers,
            body: options.body,
        });

        if (!response.ok) {
            throw new Error('Error de conexión con el servidor');
        }

        let res;
        try {
            res = await response.json();
        } catch (e) {
            throw new Error('Respuesta no válida del servidor');
        }

        if (!res || res.status !== 'success') {
            const msg = (res && res.msg) ? res.msg : 'Ocurrió un error';
            const error = new Error(msg);
            error.status = res ? res.status : 'error';
            throw error;
        }

        return res.data;
    }

    buildParams(obj) {
        const params = new URLSearchParams();
        Object.keys(obj).forEach((k) => {
            const v = obj[k];
            if (v !== undefined && v !== null && v !== '') {
                params.set(k, v);
            }
        });
        return params.toString();
    }

    listStores(filters = {}) {
        const qs = this.buildParams({
            page: filters.page,
            per_page: filters.per_page,
            prefix: filters.prefix,
            search: filters.search,
            status: filters.status,
        });
        return this.request(`${endpointBiblioList}?${qs}`);
    }

    getStore(prefix) {
        const qs = this.buildParams({ prefix });
        return this.request(`${endpointBiblioGet}?${qs}`);
    }

    listAvailableAccounts() {
        return this.request(endpointBiblioAvailableAccounts);
    }

    createStore(payload) {
        return this.request(endpointBiblioCreate, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    updateStore(payload) {
        return this.request(endpointBiblioUpdate, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    deployStore(prefix) {
        return this.request(endpointBiblioDeploy, {
            method: 'POST',
            body: JSON.stringify({ prefix }),
        });
    }

    pauseStore(prefix, active) {        return this.request(endpointBiblioPause, {
            method: 'POST',
            body: JSON.stringify({ prefix, active }),
        });
    }

    deleteStore(prefix) {
        return this.request(endpointBiblioDelete, {
            method: 'POST',
            body: JSON.stringify({ prefix }),
        });
    }

    getReport(filters = {}) {
        const qs = this.buildParams({
            prefix: filters.prefix,
            init: filters.init,
            end: filters.end,
            currency: filters.currency,
        });
        return this.request(`${endpointBiblioReport}?${qs}`);
    }
}

const BiblioServiceInstance = new BiblioService();

export default BiblioServiceInstance;
